import { createSlice } from "@reduxjs/toolkit";

const optionsSlice = createSlice({
  name: "masterData",
  initialState: {
    isLoading: false,
    masterDataList: [],
    currentMasterData: {},
  },
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setMasterDataList(state, action) {
      state.masterDataList = action.payload;
    },
    setCurrentMasterData(state, action) {
      state.currentMasterData = action.payload;
    },
  },
});

export const { setIsLoading, setMasterDataList, setCurrentMasterData } =
  optionsSlice.actions;
export default optionsSlice.reducer;
